/* eslint-disable */
// @ts-nocheck
import React from 'react';
import './mock-badge.css';

/**
 * Inline pill — sits next to a value or table cell that is mock data.
 *   <span>Dr. Masson <MockBadge /></span>
 */
export function MockBadge({ label = 'DEMO' }) {
  return (
    <span title="Demo data — not yet wired to live source" className="mb-badge">
      {label}
    </span>
  );
}

/**
 * Top-of-section banner — placed at the top of an entire tab or widget
 * that is mostly or entirely demo data.
 *   <MockBanner message="This tab shows demo data until the backend is wired." />
 */
export function MockBanner({ message }) {
  return (
    <div className="mb-banner">
      <span className="mb-banner-tag">Demo Data</span>
      <span className="mb-banner-msg">{message}</span>
    </div>
  );
}
